import { isDefined } from '@sgme/fp';
import clsx from 'clsx';
import { use } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  TargetAccumulatorContext,
  useTargetAccumulatorSelector,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import {
  getTargetAccumulatorMarketData,
  selectTargetAccumulatorCurrencyPair,
} from '@/store/targetAccumulator/selectors.ts';
import { useCurrencyPrecision } from '@/utils/currencies/useCurrencyPrecision.ts';

const Forward = () => {
  const { formatNumber } = useIntl();
  const { tileId } = use(TargetAccumulatorContext);
  const currencyPair = useAppSelector((state) => selectTargetAccumulatorCurrencyPair(state, tileId));

  const marketData = useTargetAccumulatorSelector((targetAccumulator) =>
    getTargetAccumulatorMarketData(targetAccumulator),
  );
  const isExpired = useTargetAccumulatorSelector(
    (targetAccumulator) => targetAccumulator.properties.rfs.status === 'EXPIRED',
  );

  const precision = useCurrencyPrecision(currencyPair);

  return (
    <div className={clsx('form-group form-group-sm d-flex my-1', { expired: isExpired })}>
      <div className="pe-1 col-form-label col-form-label-sm col-4 text-nowrap text-end" style={{ width: '30%' }}>
        <FormattedMessage id="accumulator.fields.forward" />
      </div>
      {isDefined(marketData?.forward) && (
        <span className="d-flex flex-column px-1 fs-6" style={{ width: '64%' }} data-e2e="forward">
          {isDefined(marketData?.forward.bid) &&
            formatNumber(marketData?.forward.bid, {
              maximumFractionDigits: precision + 1,
              minimumFractionDigits: precision + 1,
            })}
          /
          {isDefined(marketData?.forward.ask) &&
            formatNumber(marketData?.forward.ask, {
              maximumFractionDigits: precision + 1,
              minimumFractionDigits: precision + 1,
            })}
        </span>
      )}
    </div>
  );
};

export default Forward;
